<template>
	<div class="not-found-container">
		<div class="emoji-oops">
			🤔
		</div>
		<div class="message">
			<p>Oops, page not found.</p>
		</div>
		<router-link to="/home" class="tp-link">Go to home page</router-link>
	</div>
</template>

<script>
	export default {}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.not-found-container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		margin: auto;
		padding: 4rem 0;

		width: 50%;

		.emoji-oops {
			font-size: 4rem;
		}
		p {
			font-size: 2rem;
		}
		.message {
			padding: 1em;
			background-color: $landingPageBackground;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue